export default class SentryWrappedError extends Error {
  public sentryTitle: string = "";
  public sentryMessage: string = "";

  constructor(message: string) {
    super(message);
  }
}
